<template>
  <div class="acc-page-holder">
    <h1 v-if="!mobileBigAndBelow">{{ promotionDescription }}</h1>
    <div v-if="mobileBigAndBelow && brandTemplate!== 'generic_2'" class="account-heading">
      {{ promotionDescription }}
    </div>
    <div class="ctsform acc-page">
      <div class="promotion-banner">
        <div class="promo-img" :style="[{backgroundImage: 'url(' + mediaServer(`/static/promotions/generic_banner_1.jpg`) + ') !important'}]">
          <p class="promotion-title">{{promotionDescription}}</p>
          <p class="promotion-text-generic">{{ $t('Promotions.BaseBannerText') }}</p>
        </div>
      </div>
      <div>{{ promotionNote }}</div>
      <div>{{ `${promotionStartText} ${formattedPromotionStart}.` }}</div>
    </div>
  </div>
</template>
<script>
  import Branding from '@/components/mixins/Branding'
  import Screen from '@/components/mixins/Screen'
  import config from '@/config'
  import moment from 'moment'
  import Url from '@/components/mixins/Url'

  export default {
    mixins: [
      Branding,
      Screen,
      Url
    ],
    data: () => {
      return {
        promotionDescription: '',
        promotionNote: '',
        promotionStart: ''
      }
    },
    computed: {
      dateFormats () {
        return config.app.dateFormats
      },
      formattedPromotionStart () {
        return this.promotionStart ? moment(this.promotionStart).format(this.dateFormats.longDate) : this.promotionStart
      },
      promotionStartText () {
        const date = new Date(this.promotionStart)
        const currentDate = new Date()
        return date > currentDate ? this.$t('f2p.promotions.start.future') : this.$t('f2p.promotions.start.past')
      }
    },
    created () {
      const promotion = this.$route.query.promotion ? JSON.parse(this.$route.query.promotion) : {}
      if (promotion) {
        this.promotionDescription = promotion.description
        this.promotionNote = promotion.note
        this.promotionStart = promotion.start
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .promo-img
    text-align: center
    padding: 25px
    border-radius: 8px
    margin: 10px
    .promotion-title
      font-family: 'Roboto Condensed Bold'
      text-transform: uppercase
      margin: 0
</style>



// WEBPACK FOOTER //
// src/components/externalintegrations/Free2PlayGamesPromotionInfo.vue